import { ChangeDetectionStrategy, Component } from '@angular/core';
@Component({
    selector: 'account-form',
    templateUrl: './account-form.html',
    styleUrls: ['./account-form.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class AccountFormComponent {
}
